import {
	ArrowButtons,
	Breakpoints,
	ContainerGutter,
	Gallery,
	GallerySlide,
	Lentils,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { isMobileBreakpoint } from '../../../helpers/breakpoint-helpers';
import { isNewBrandDesign } from '../../../helpers/color-tokens';
import { NovedadesCard } from './novedades-card';
import { NovedadesItem } from '@esportal/portal-service';
import { IContextNovedades } from '../models/context-novedades';
import { useIsLandscape } from '../../../hooks/use-is-landscape';

// añadir padding a las gallery slides para la shadow de la card
const GallerySlideContainer = styled(GallerySlide)`
	padding: ${isNewBrandDesign() ? '0px' : '10px'};
`;

export const LentilsWrapper = styled.div<{ $count: number; $slidesAt960: number }>`
	padding-top: var(--size-dynamic0050);
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: var(--size-dynamic0100);
	margin-bottom: var(--size-dynamic0100);

	/* ocultar si todas las slides caben en pantalla */
	${({ $count }) => $count <= 1 && `display: none;`}

	@media (min-width: 960px) {
		${({ $count, $slidesAt960 }) => $count <= $slidesAt960 && `display: none;`}
	}

	@media (min-width: 2560px) {
		${({ $count }) => $count <= 4 && `display: none;`}
	}
`;

interface NovedadesCarouselProps {
	novedades: NovedadesItem[];
	context: React.Context<IContextNovedades>;
}

export const NovedadesCarousel = ({ novedades, context }: NovedadesCarouselProps) => {
	const isMobile = isMobileBreakpoint(Breakpoints.b960);
	const isLandscape = useIsLandscape();
	const slidesAt960 = isLandscape ? 3 : 2;
	return (
		<Gallery
			data-testid="novedades-gallery-slider"
			id="novedades-gallery"
			bottomElements={
				<>
					<ArrowButtons buttonPreviousAriaLabel="To previous slide" buttonNextAriaLabel="To next slide" />

					{/* si todas las slides caben en pantalla - no mostrar lentils */}
					<LentilsWrapper $count={novedades.length} $slidesAt960={slidesAt960}>
						<Lentils />
					</LentilsWrapper>
				</>
			}
			aria-label="novedades gallery"
			slidesPerPage={{
				[Breakpoints.default]: 1,
				[Breakpoints.b960]: novedades.length >= slidesAt960 ? slidesAt960 : novedades.length,
				[Breakpoints.b2560]: novedades.length >= 4 ? 4 : novedades.length,
			}}
			fadingEdges="normal"
			gutter={!isMobile ? ContainerGutter.dynamic0100 : undefined}
		>
			{[
				...novedades.map((novedadesItem, index) => (
					<GallerySlideContainer key={index} aria-labelledby={`slide${index}-heading`} stretch>
						<NovedadesCard novedadesItem={novedadesItem} context={context} />
					</GallerySlideContainer>
				)),
			]}
		</Gallery>
	);
};
